module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1033-9bbff4ed59b16639e53ba64b63dab8f0.png";